var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1114 8.67401L4.91544 0.478049C4.60876 0.171821 4.19313 0 3.75992 0C3.32656 0 2.91092 0.171829 2.60425 0.478049L0.479717 2.60468C0.172729 2.91045 0 3.32594 0 3.75915C0 4.19251 0.172736 4.60799 0.479717 4.91377L8.66714 13.1097L14 14.1025L13.1114 8.67401ZM12.21 9.90772L12.4555 11.4066L11.3563 12.5058L9.88577 12.2321L12.21 9.90772ZM6.03849 3.13885L3.13424 6.04326L2.89528 5.80431L5.79954 2.8999L6.03849 3.13885ZM1.08151 3.76237C1.08136 3.61721 1.13924 3.47796 1.24227 3.37568L3.37103 1.24692C3.47574 1.14736 3.61453 1.09191 3.75878 1.09191C3.90319 1.09191 4.04198 1.14736 4.14653 1.24692L5.04157 2.13106L2.12642 5.03531L1.24228 4.15117C1.13864 4.04844 1.08075 3.90827 1.08151 3.76237ZM3.90546 6.80343L6.80549 3.90783L11.7431 8.84309L8.83883 11.7473L3.90546 6.80343Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/draft.454d66a9f91bc0bfb5de74f7bb9d70f2.svg";
export { ForwardRef as ReactComponent };